import { CinemaService } from 'api/cinemaClub/service';
import { useCallback } from 'react';


export const useCinema = () => {
    const onGetAllCinema = useCallback(async () => {
        try {
            const response = await CinemaService.getInstance().findAll();

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetOneCinema = useCallback(async (id: number) => {
        try {
            const response = await CinemaService.getInstance().findOne(id);

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    return { onGetAllCinema, onGetOneCinema };
};
